<div *ngFor="let group of groups; let first = first" class="pt-4 pb-3 text-sm"
  [class.border-t]="!first || firstSectionBorder" [class.border-gray-200]="!first || firstSectionBorder">
  <h3 class="font-semibold text-gray-700 !mb-2">{{group.title}}</h3>
  <div class="mt-2">
    <div [ngClass]="group.isDine ? 'grid grid-cols-2 gap-2 text-sm' : ''">
      <div *ngFor="let item of group.items" class="flex items-center">
        <span class="mr-1">{{item.icon}}</span> {{item.label}}
      </div>
    </div>
  </div>
</div>
